import axios from "axios";
import moment from "moment";
import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    cochesImages: [],
    coches: [],
    coche: {},
  },
  mutations: {
    llenarCoches(state, data) {
      state.coches = data;
      bus.$emit('cargarLista');
    },
    llenarCoche(state, data) {
      state.coche = data;
    },
    llenarImages(state, data) {
      state.cochesImages = data;
    },
  },
  actions: {
    getCoches: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("coche/list", configuracion)
        .then(function(response) {
          response.data.forEach((element) => {
            element.createdAt = moment(element.createdAt).format("LL");
          });
          data = response.data;
          commit("llenarCoches", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getImages: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("coche/image-all", configuracion)
        .then(function(response) {
          data = response.data.resources;
          commit("llenarImages", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getCoche: async function({ commit }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;

      await axios
        .get(`coche/query?id=${data.id}`, configuracion)
        .then(function(response) {
          d = response.data.detalles;
          commit("llenarCoche", d);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveCoche: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;

      await axios
        .post(
          "coche/add",
          {
            usuario: data.usuario,
            grupo: data.obj.grupo,
            dalquiler: data.obj.dalquiler,
            aventa: data.obj.aventa,
            taller: data.obj.taller,
            vendido: data.obj.vendido,
            matricula: data.obj.matricula,
            marca: data.obj.marca,
            modelo: data.obj.modelo,
            observaciones: data.obj.observaciones,
            color: data.obj.color,
            bastidor: data.obj.bastidor,
            km_actual: data.obj.km_actual,
            km_compra: data.obj.km_compra,
            fecha_compra: data.obj.fecha_compra,
            puertas: data.obj.puertas,
            transmision: data.obj.transmision,
            plazas: data.obj.plazas,
            radio: data.obj.radio,
            tipo_combustible: data.obj.tipo_combustible,
            combustible_actual: data.obj.combustible_actual,
            tanque: data.obj.tanque,
            fecha_alta: data.obj.fecha_alta,
            fecha_matriculacion: data.obj.fecha_matriculacion,
            fecha_limite: data.obj.fecha_limite,
            fecha_itv: data.obj.fecha_itv,
            precio_compra: data.obj.precio_compra,
            precio_venta: data.obj.precio_venta,
            imagen: data.obj.imagen,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getCoches", data.token);
          swal({
            title: "Buen trabajo!",
            text: `El coche con matrícula ${res.data.matricula} fue agregado correctamente`,
            icon: "success",
          });
          if (data.obj.image != null && data.obj.image != "unidefined" && data.obj.image != "") {
            const formData = new FormData();
            formData.append("file0", data.obj.image, data.obj.image.name);

            axios
              .post(`coche/upload-image/${res.data.id}`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                console.log(response);
              })
              .catch((err) => {
                swal({
                  title: "Algo anda mal",
                  text: `La imagen no pudo ser subida`,
                  icon: "error",
                });
              });
          }
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    updateCoche: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "coche/update",
          {
            id: data.obj.id,
            usuario: data.usuario,
            grupo: data.obj.grupo,
            dalquiler: data.obj.dalquiler,
            taller: data.obj.taller,
            aventa: data.obj.aventa,
            vendido: data.obj.vendido,
            matricula: data.obj.matricula,
            marca: data.obj.marca,
            modelo: data.obj.modelo,
            observaciones: data.obj.observaciones,
            color: data.obj.color,
            bastidor: data.obj.bastidor,
            km_actual: data.obj.km_actual,
            km_compra: data.obj.km_compra,
            fecha_compra: data.obj.fecha_compra,
            puertas: data.obj.puertas,
            transmision: data.obj.transmision,
            plazas: data.obj.plazas,
            radio: data.obj.radio,
            tipo_combustible: data.obj.tipo_combustible,
            combustible_actual: data.obj.combustible_actual,
            tanque: data.obj.tanque,
            fecha_alta: data.obj.fecha_alta,
            fecha_matriculacion: data.obj.fecha_matriculacion,
            fecha_limite: data.obj.fecha_limite,
            fecha_itv: data.obj.fecha_itv,
            precio_compra: data.obj.precio_compra,
            precio_venta: data.obj.precio_venta,
            imagen: data.obj.imagen,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getCoches", data.token);
          swal({
            title: "Buen trabajo!",
            text: `El coche con matrícula ${res.data.matricula} fue editado correctamente`,
            icon: "success",
          });
          if (
            data.obj.image != null &&
            data.obj.image != "unidefined" &&
            data.obj.image != ""
          ) {
            const formData = new FormData();
            formData.append("file0", data.obj.image, data.obj.image.name);

            axios
              .post(`coche/upload-image/${res.data.id}`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((response) => {
                console.log(response);
              })
              .catch((err) => {
                swal({
                  title: "Algo anda mal",
                  text: `La imagen no pudo ser subida`,
                  icon: "error",
                });
              });
          }
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteCoche: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .delete(`coche/remove?id=${data.id}`, configuracion)
        .then(function() {
          dispatch("getCoches", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Coche eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
          console.log(error);
        });
    },
  },
};
